import clickOutside from '@/plugins/clickoutside';
import globalComponents from '@/plugins/globalComponents';
import store from '@/store'
import '@/scss/main.scss';

export default {
    install(Vue){
        Vue.use(clickOutside,store);
        Vue.use(globalComponents);
    }
}